import { FormikProvider, useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";

import { signup } from "services";

import { Content, Forms, Grid, Modals } from "components";
import { useCallback } from "react";

import { useDebounce } from "hooks/debounce";
import { companyPartner } from "../../../schema";

const initialValues = {
  document: "",
  name: "",
  percentage: "",
};

export type PartnerValues = typeof initialValues;

const PartnerRegister = (props: any) => {
  const isEditing = useMemo(() => !!props.initialValues, [props.initialValues]);

  const form = useFormik<PartnerValues>({
    initialValues: props.initialValues || initialValues,
    validationSchema: companyPartner,
    onSubmit: (values) => {
      props.onSubmit(values);
    },
  });

  const [status, setStatus] = useState<
    "fetching-document" | "fetched-document" | ""
  >("");

  const [document_, setDocument] = useState("");
  const document = useDebounce(document_);

  const fetchDocumentDetails = useCallback(async () => {
    try {
      setStatus("fetching-document");

      const partnerType = document.length > 14 ? "legal_entity" : "individual";

      const partner = await {
        individual: () => signup.findPersonByDocument(document),
        legal_entity: () => signup.findCompanyByDocument(document),
      }[partnerType]();

      form.setFieldValue("name", partner.name);
    } finally {
      setStatus("fetched-document");
    }
  }, [document]);

  useEffect(() => {
    if (document && !form.errors.document) fetchDocumentDetails();
  }, [document]);

  useEffect(() => {
    if (isEditing) setStatus("fetched-document");
  }, []);

  return (
    <Modals.Content
      icon="person"
      title={isEditing ? form.values.name : "Cadastrar sócio"}
      onCancel={{
        text: "Cancelar",
        onClick: props.onDismiss,
      }}
      onSubmit={{
        text: isEditing ? "Salvar alterações" : "Cadastrar sócio",
        onClick: () => form.handleSubmit(),
      }}
    >
      <FormikProvider value={form}>
        <Grid gap={[".5rem", "1rem"]}>
          <Forms.InputGroup
            name="document"
            label="CPF/CNPJ"
            placeholder="Digite o CPF/CNPJ"
            mask="document"
            onKeyUp={(event) => {
              setDocument(event.target.value);
            }}
          />

          {status === "fetching-document" && (
            <Content.Loader message="Aguarde, buscando as informações" />
          )}
          {status === "fetched-document" && (
            <>
              <Forms.InputGroup
                name="name"
                label="Nome/Razão social"
                placeholder="Digite o nome/Razão social"
              />

              <Forms.InputGroup
                name="percentage"
                label="Porcentagem de participação"
                placeholder="Digite a porcentagem de participação"
                mask="percentage"
              />
            </>
          )}
        </Grid>
      </FormikProvider>
    </Modals.Content>
  );
};

// eslint-disable-next-line
export default (props?: any) =>
  Modals.Promised.createModal(PartnerRegister, props);
